import mutations from "@/store/modules/alertV2/extTagGrouping/extTagGrouping.mutations";
import getters from "@/store/modules/alertV2/extTagGrouping/extTagGrouping.getters";
import actions from "@/store/modules/alertV2/extTagGrouping/extTagGrouping.actions";
import _ from "lodash";
import {
  extTagTableInfo,
  formUtilsDefaultData,
  extTagFormDefaultData,
  defaultErrorValues,
  webhookDefaultData
} from "@/components/AlertsV2/external-tag-grouping/extTags.types";
import {
  FormUtils,
  ExtTagTableInfo,
} from "@/store/modules/alertV2/extTagGrouping/interfaces";

export interface ExtTagFormData {
  tagInfo: TagInfo,
  extTagFields: Object;
  extTagConditions: Object;
  webhook: Webhook;
}
export interface TagInfo {
  tagName: string;
  tagGroupName: string;
  fmId: string;
  active: boolean;
  templateId: string;
}
interface Webhook {
  id: string,
  url: string,
  method: string,
}

export interface ErrorInForm {
  tagInfo: boolean,
  webhookInfo: boolean
}

export interface WebhookMapping {
  conditionType: any[],
  fmid: string,
  map: any[],
  webhook: {}
}

export interface State {
  isExtTagFormOpened: boolean;
  isExtTagFormEdit: boolean;
  extTagTableInfo: ExtTagTableInfo;
  formUtils: FormUtils;
  webhookMapping: WebhookMapping;
  extTagFormData: ExtTagFormData;
  isErrorInForm: ErrorInForm;
  defaulKeytMapping : any,
  isClearEnabled: boolean,
  newTagGrpAllowed: boolean,
}

export const initialState: State = {
  isExtTagFormOpened: false,
  isExtTagFormEdit: false,
  extTagTableInfo: _.cloneDeep(extTagTableInfo),
  formUtils: _.cloneDeep(formUtilsDefaultData),
  webhookMapping: _.cloneDeep(webhookDefaultData),
  extTagFormData: _.cloneDeep(extTagFormDefaultData),
  isErrorInForm: _.cloneDeep(defaultErrorValues),
  defaulKeytMapping : {},
  isClearEnabled: false,
  newTagGrpAllowed: true,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  getters: getters,
  actions: actions,
};
